import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';
import { DefaultButton } from '@fluentui/react/lib';

const DisclaimerModal: React.FC<{acceptHandler:() => void}> = (props) => { 
    const { t } = useTranslation();
    return (
        <div className="rs-modal-background">
            <div className="rs-modal-container">
                <div className="rs-modal-header">
                    <h2>{t('disclaimer.headline')}</h2>
                </div>
                <div className="rs-modal-text">
                    <div dangerouslySetInnerHTML={{__html:t('disclaimer.text')}} />
                </div>
                <div className="rs-modal-footer">
                    <DefaultButton 
                        text={t('buttons.accept')} 
                        onClick={props.acceptHandler} 
                    />
                </div>
            </div>
        </div>
    )
}

export default DisclaimerModal;